

import { Designer, Profile } from '@brg/api';
import { ProfileUtils } from 'core/auth';
import { TGlobal, TLocal } from '@brg/api';
import { isNotEmptyArray } from '@brg/is';

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetDesignerName(designer: Designer<TGlobal | TLocal>): [string, string?] {
    if (!designer) return ['Undefined', 'Undefined'];

    const name = designer.name ? String(designer.name) : 'Unnamed';
    if (name === 'Unnamed') return [name];
    const lastname = designer.surName ? String(designer.surName) : '';
    return [name, lastname];
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetProfileName(designer: Profile<TGlobal | TLocal>): [string, string?] {
    if (!designer) return ['Undefined', 'Undefined'];

    const name = designer.name ? String(designer.name) : 'Unnamed';
    if (name === 'Unnamed') return [name];
    const lastname = designer.surName ? String(designer.surName) : '';
    return [name, lastname];
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetDesignerWords(designer: Designer) {
    const data = GetDesignerName(designer);
    if (data.length === 1) return data[0].substr(0, 1);
    return data[0].substr(0, 1) + data[1]?.substr(0, 1);
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetProfileWords(designer: Profile) {
    const data = GetProfileName(designer);
    if (data.length === 1) return data[0].substr(0, 1);
    return data[0].substr(0, 1) + data[1]?.substr(0, 1);
}

export const DesignerUtils = {
    hasAvatar(designer?: Partial<Designer>): boolean {
        return !!designer && isNotEmptyArray(designer.avatar);
    },

    /**
     * Returns the designer name
     * @deprecated
     * @param designer
     */
    getDesignerNameArray(designer: Designer): [string, string] {
        // @ts-ignore
        return ProfileUtils.getFullName(designer);
    },

    /**
     * Returns designer NAME
     * @deprecated
     * @param designer
     */
    getDesignerName(designer: Designer): string {
        return DesignerUtils.getDesignerNameArray(designer).join(' ');
    },

    /**
     * Returns the designer HIGH words, for example: Yakov Fox == YF
     * @deprecated
     * @param designer
     */
    getDesignerWords(designer: Designer): string {
        return ProfileUtils.getLetters(designer);
    },

    getShortVariantName(designer?: Partial<Designer>): string {
        const name = ProfileUtils.getFullName(designer as any, 'Unnamed', false as any);
        if (!name[1]) return name[0];
        if (name.length > 1) {
            return name[0].substr(0, 1) + '. ' + name[1];
        }
        return name[0];
    },

    hasSocial(social: string, designer?: Partial<Designer>): boolean {
        return !!designer && !!designer.socialNetworks && !!designer.socialNetworks.find((v) => v.name === social);
    },
};


import { Designer, Profile } from '@brg/api';
import { ProfileUtils } from 'core/auth';
import { TGlobal, TLocal } from '@brg/api';
import { isNotEmptyArray } from '@brg/is';

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetDesignerName(designer: Designer<TGlobal | TLocal>): [string, string?] {
    if (!designer) return ['Undefined', 'Undefined'];

    const name = designer.name ? String(designer.name) : 'Unnamed';
    if (name === 'Unnamed') return [name];
    const lastname = designer.surName ? String(designer.surName) : '';
    return [name, lastname];
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetProfileName(designer: Profile<TGlobal | TLocal>): [string, string?] {
    if (!designer) return ['Undefined', 'Undefined'];

    const name = designer.name ? String(designer.name) : 'Unnamed';
    if (name === 'Unnamed') return [name];
    const lastname = designer.surName ? String(designer.surName) : '';
    return [name, lastname];
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetDesignerWords(designer: Designer) {
    const data = GetDesignerName(designer);
    if (data.length === 1) return data[0].substr(0, 1);
    return data[0].substr(0, 1) + data[1]?.substr(0, 1);
}

/**
 * @deprecated
 * @param designer
 * @constructor
 */
export function GetProfileWords(designer: Profile) {
    const data = GetProfileName(designer);
    if (data.length === 1) return data[0].substr(0, 1);
    return data[0].substr(0, 1) + data[1]?.substr(0, 1);
}

export const DesignerUtils = {
    hasAvatar(designer?: Partial<Designer>): boolean {
        return !!designer && isNotEmptyArray(designer.avatar);
    },

    /**
     * Returns the designer name
     * @deprecated
     * @param designer
     */
    getDesignerNameArray(designer: Designer): [string, string] {
        // @ts-ignore
        return ProfileUtils.getFullName(designer);
    },

    /**
     * Returns designer NAME
     * @deprecated
     * @param designer
     */
    getDesignerName(designer: Designer): string {
        return DesignerUtils.getDesignerNameArray(designer).join(' ');
    },

    /**
     * Returns the designer HIGH words, for example: Yakov Fox == YF
     * @deprecated
     * @param designer
     */
    getDesignerWords(designer: Designer): string {
        return ProfileUtils.getLetters(designer);
    },

    getShortVariantName(designer?: Partial<Designer>): string {
        const name = ProfileUtils.getFullName(designer as any, 'Unnamed', false as any);
        if (!name[1]) return name[0];
        if (name.length > 1) {
            return name[0].substr(0, 1) + '. ' + name[1];
        }
        return name[0];
    },

    hasSocial(social: string, designer?: Partial<Designer>): boolean {
        return !!designer && !!designer.socialNetworks && !!designer.socialNetworks.find((v) => v.name === social);
    },
};
